import { Button } from '@monksflow/monks-ui';
import { PlusIcon } from 'lucide-react';
import { ManualEntryCard } from './ManualEntryCard';
import type { CreateManuallyTabProps } from './shared.types';

export const CreateManuallyTab = ({
  entries,
  label,
  namePlaceholder,
  detailsPlaceholder,
  addButtonLabel,
  onAdd,
  onUpdate,
  onRemove,
}: CreateManuallyTabProps) => {
  return (
    <div className="flex flex-col gap-md">
      {entries.map((entry, index) => (
        <ManualEntryCard
          key={entry.id}
          entry={entry}
          index={index}
          label={label}
          namePlaceholder={namePlaceholder}
          detailsPlaceholder={detailsPlaceholder}
          onUpdate={onUpdate}
          onRemove={entries.length > 1 ? onRemove : undefined}
        />
      ))}
      <Button type="button" variant="outline" onClick={onAdd} className="w-fit">
        <PlusIcon />
        {addButtonLabel}
      </Button>
    </div>
  );
};
